export class Location {
    locationId;
    source;
    label;
    position;
    geocoder;
    score = 1.0;
    constructor(locationId, source, label, geocoder, position, score = 1.0) {
        this.locationId = locationId;
        this.source = source;
        this.label = label;
        this.position = position;
        this.geocoder = geocoder;
        this.score = score;
    }
    static createFromInfra3dGeocoder(id, payload) {
        return new Location(id, payload.source, payload.name, payload.title, {
            lat: payload.position[1],
            lon: payload.position[0],
        }, 1.0);
    }
    static createFromLinrefCoder(payload) {
        return new Location(payload.id.toString(), payload.dataset, payload.name, "KM-Points", {
            lat: payload.latitude,
            lon: payload.longitude,
        }, payload.score);
    }
    static createFromGeoJSON(feature, source, label) {
        return new Location(feature.id.toString(), feature.properties[source], feature.properties[label], "Points of Interest", {
            lat: feature.geometry.coordinates[1],
            lon: feature.geometry.coordinates[0],
        }, 1);
    }
    static createFromHERE(feature, latlon) {
        return new Location(feature.id, "HERE", feature.address.label, "HERE", latlon, 1);
    }
}
//# sourceMappingURL=location.js.map